exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#signatureBox[data-v-8247cd82] {\n    background-color: lightgray;\n    border: 1px dotted gray;\n}\nh4[data-v-8247cd82] {\n    color: white;\n}\n", ""]);

// exports
